"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAxeDescription = void 0;
const getAxeDescription = (tierName, externalUrl) => [
    `When this ${tierName} Pickaxe is equipped by a COIN user it enhances many features related to Geomining. Every pickaxe is visually unique and gives its own distinct set of benefits.`,
    `The more scarce a pickaxe is, the bigger these benefits are.`,
    externalUrl
        ? `Check out the details of this ${tierName} Pickaxe here: ${externalUrl}`
        : "",
]
    .filter((v) => v)
    .join(" ");
exports.getAxeDescription = getAxeDescription;
//# sourceMappingURL=description.js.map